import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVanuatu = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1255)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9999 12C23.9999 11.4696 23.9651 10.9472 23.8984 10.4348H10.4346C7.98302 7.98337 3.51449 3.51511 3.51467 3.51474C-1.1716 8.20102 -1.1716 15.799 3.51467 20.4853L10.4348 13.5653H23.8984C23.9651 13.0529 23.9999 12.5305 23.9999 12Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9965 12.2729C23.996 12.2961 23.9955 12.3193 23.9948 12.3425C23.9954 12.3192 23.996 12.2961 23.9965 12.2729Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.985 12.6009C23.9839 12.6238 23.9823 12.6466 23.9811 12.6695C23.9823 12.6467 23.9838 12.6238 23.985 12.6009Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9688 12.8624C23.9664 12.8961 23.9641 12.9298 23.9614 12.9634C23.9641 12.9298 23.9664 12.8961 23.9688 12.8624Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9287 10.6921C23.9331 10.7322 23.9376 10.7723 23.9415 10.8125C23.9376 10.7723 23.9331 10.7322 23.9287 10.6921Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.981 11.3305C23.9823 11.3534 23.9839 11.3762 23.9849 11.3991C23.9838 11.3762 23.9823 11.3533 23.981 11.3305Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9948 11.6576C23.9954 11.6807 23.9959 11.704 23.9965 11.7272C23.996 11.7039 23.9954 11.6807 23.9948 11.6576Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9614 11.0366C23.9641 11.0702 23.9664 11.1039 23.9688 11.1376C23.9664 11.1039 23.9641 11.0702 23.9614 11.0366Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.8984 10.4348C23.9038 10.4759 23.9085 10.5172 23.9135 10.5585C23.2013 4.61087 18.1394 6.10352e-05 12 6.10352e-05C8.6862 6.10352e-05 5.68616 1.34326 3.51459 3.51493L10.4344 10.4348H23.8984V10.4348Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.8984 13.5652H10.4344L3.51459 20.4851C5.68616 22.6567 8.6862 24 12 24C18.1394 24 23.2013 19.3892 23.9135 13.4416C23.9085 13.4828 23.9037 13.5241 23.8984 13.5652Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9415 13.1875C23.9375 13.2277 23.9331 13.2678 23.9287 13.3079C23.9331 13.2678 23.9376 13.2277 23.9415 13.1875Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9688 11.1376C23.9734 11.2017 23.9775 11.2661 23.981 11.3305C23.9775 11.2661 23.9734 11.2017 23.9688 11.1376Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9135 10.5584C23.9189 10.6029 23.924 10.6475 23.9288 10.6921C23.9239 10.6475 23.9188 10.603 23.9135 10.5584Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9415 10.8125C23.9488 10.887 23.9554 10.9617 23.9614 11.0366C23.9555 10.9617 23.9489 10.887 23.9415 10.8125Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9999 12C23.9999 12.0913 23.9985 12.1822 23.9965 12.2729C23.9985 12.1821 23.9999 12.0912 23.9999 12Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9811 12.6695C23.9775 12.7339 23.9734 12.7983 23.9689 12.8624C23.9734 12.7983 23.9774 12.7339 23.9811 12.6695Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9614 12.9634C23.9554 13.0383 23.9488 13.113 23.9415 13.1875C23.9489 13.113 23.9555 13.0383 23.9614 12.9634Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9288 13.3079C23.924 13.3525 23.9189 13.397 23.9135 13.4416C23.9188 13.3971 23.9239 13.3525 23.9288 13.3079Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9965 11.7271C23.9985 11.8179 23.9999 11.9088 23.9999 12C23.9999 11.9088 23.9985 11.8179 23.9965 11.7271Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.985 11.3991C23.9892 11.485 23.9924 11.5712 23.9948 11.6576C23.9924 11.5712 23.9893 11.485 23.985 11.3991Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9948 12.3425C23.9924 12.4288 23.9892 12.515 23.985 12.6009C23.9893 12.515 23.9924 12.4288 23.9948 12.3425Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9885 11.474H9.9938L2.8052 4.28644C2.57284 4.5315 2.32099 4.87369 2.16522 5.11739L9.03985 11.9956L2.15945 18.8762C2.29567 19.1185 2.59244 19.4772 2.8008 19.7106L9.99394 12.5174H23.9902C23.9977 12.3444 24 12.1706 24 11.9957C24 11.7614 23.9935 11.5887 23.9885 11.474Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.91502 14.5581V13.553C3.91805 13.553 4.734 12.7369 4.734 11.734C4.734 11.0243 4.15664 10.447 3.44705 10.447C2.96363 10.447 2.5703 10.8403 2.5703 11.3238C2.5703 11.633 2.82179 11.8845 3.13098 11.8845C3.30572 11.8845 3.4479 11.7422 3.4479 11.5675H4.45299C4.45299 12.2965 3.85993 12.8896 3.13102 12.8896C2.26763 12.8896 1.56531 12.1872 1.56531 11.3239C1.56531 10.2862 2.40952 9.44208 3.4471 9.44208C4.71094 9.44208 5.73919 10.4703 5.73919 11.7341C5.73914 13.2912 4.47225 14.5581 2.91502 14.5581Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1255",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgVanuatu;
